import React from 'react'
import SchedulesHomeNavigation from './SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../UIElements/SearchByLeagueOrVenue'
import FullSchedule from '../../schedule/FullSchedule'

const SchedulesHome = () => {
	return (
		<div>
			<SchedulesHomeNavigation />
			<SearchByLeagueOrVenue />
			<FullSchedule />
		</div>
	)
}

export default SchedulesHome
